class FinkpoTestimonialSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.finkpo-testimonials__slide'));
    this.dots = Array.from(this.querySelectorAll('.finkpo-testimonials__dot'));
    this.current = 0;
    this.autoplayDelay = parseInt(this.dataset.autoplay, 10) || 6000;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.slides.length <= 1) return;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goTo(index);
        this.resetAutoplay();
      });
    });

    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
    this.addEventListener('focusin', () => this.stopAutoplay());
    this.addEventListener('focusout', () => this.startAutoplay());

    if (!this.reducedMotion) {
      this.startAutoplay();
    }
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  goTo(index) {
    if (index === this.current) return;
    this.slides[this.current].classList.remove('is-active');
    this.dots[this.current]?.setAttribute('aria-selected', 'false');
    this.current = index;
    this.slides[this.current].classList.add('is-active');
    this.dots[this.current]?.setAttribute('aria-selected', 'true');
  }

  next() {
    this.goTo((this.current + 1) % this.slides.length);
  }

  startAutoplay() {
    if (this.reducedMotion) return;
    this.stopAutoplay();
    this.timer = setInterval(() => this.next(), this.autoplayDelay);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  resetAutoplay() {
    if (this.timer) {
      this.startAutoplay();
    }
  }
}

customElements.define('finkpo-testimonial-slider', FinkpoTestimonialSlider);
